import React from 'react';
import { Container, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <Container sx={{ textAlign: 'center', mt: 8 }}>
      <Typography variant="h3" gutterBottom>
        {t('notFound.title')}
      </Typography>
      <Typography variant="body1" gutterBottom>
        {t('notFound.description')}
      </Typography>
      <Button variant="contained" color="primary" component={Link} to="/">
        {t('notFound.home')}
      </Button>
    </Container>
  );
};

export default NotFoundPage;
